import { render, staticRenderFns } from "./TagGroups.vue?vue&type=template&id=31bdeda2"
import script from "./TagGroups.vue?vue&type=script&lang=js"
export * from "./TagGroups.vue?vue&type=script&lang=js"
import style0 from "./TagGroups.vue?vue&type=style&index=0&id=31bdeda2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports